import { locationLocales } from '@/documents/vpnHomeContent';

const localizedNavigation = {
  en: {
    home: 'Home',
    webProxy: 'Web Proxy',
    forPc: 'For PC',
    ipChecker: 'IP Checker',
    resources: 'Resources',
    locations: 'Locations',
    blog: 'Blogs',
    guides: 'VPN Guides',
    about: 'About Us',
    contact: 'Contact Us',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
    disclaimer: 'Disclaimer',
    footer:
      'Secure VPN provides VPN guides, feature information, and online privacy resources.',
  },
  ru: {
    home: 'Главная',
    webProxy: 'Веб-прокси',
    forPc: 'Для ПК',
    ipChecker: 'Проверка IP',
    resources: 'Ресурсы',
    locations: 'Локации',
    blog: 'Блог VPN',
    guides: 'Руководства',
    about: 'О нас',
    contact: 'Связаться',
    privacy: 'Конфиденциальность',
    terms: 'Условия',
    disclaimer: 'Отказ от ответственности',
    footer:
      'Secure VPN публикует руководства, информацию о функциях и материалы о приватности в интернете.',
  },
  ko: {
    home: '홈',
    webProxy: '웹 프록시',
    forPc: 'PC용',
    ipChecker: 'IP 확인',
    resources: '리소스',
    locations: '지역',
    blog: 'VPN 블로그',
    guides: 'VPN 가이드',
    about: '회사 소개',
    contact: '문의',
    privacy: '개인정보 처리방침',
    terms: '이용약관',
    disclaimer: '면책 고지',
    footer:
      'Secure VPN은 VPN 가이드, 기능 정보와 온라인 개인정보 보호 자료를 제공합니다.',
  },
  hi: {
    home: 'होम',
    webProxy: 'वेब प्रॉक्सी',
    forPc: 'PC के लिए',
    ipChecker: 'IP चेकर',
    resources: 'संसाधन',
    locations: 'लोकेशन',
    blog: 'VPN ब्लॉग',
    guides: 'VPN गाइड',
    about: 'हमारे बारे में',
    contact: 'संपर्क करें',
    privacy: 'प्राइवेसी नीति',
    terms: 'उपयोग की शर्तें',
    disclaimer: 'डिस्क्लेमर',
    footer:
      'Secure VPN, VPN गाइड, फीचर जानकारी और ऑनलाइन प्राइवेसी संसाधन उपलब्ध कराता है।',
  },
  ja: {
    home: 'ホーム',
    webProxy: 'ウェブプロキシ',
    forPc: 'PC向け',
    ipChecker: 'IPチェッカー',
    resources: 'リソース',
    locations: '地域',
    blog: 'VPNブログ',
    guides: 'VPNガイド',
    about: '会社概要',
    contact: 'お問い合わせ',
    privacy: 'プライバシーポリシー',
    terms: '利用規約',
    disclaimer: '免責事項',
    footer:
      'Secure VPNはVPNガイド、機能情報、オンラインプライバシーに関する情報を提供します。',
  },
  fr: {
    home: 'Accueil',
    webProxy: 'Proxy web',
    forPc: 'Pour PC',
    ipChecker: 'Vérifier l’IP',
    resources: 'Ressources',
    locations: 'Pays',
    blog: 'Blog VPN',
    guides: 'Guides VPN',
    about: 'À propos',
    contact: 'Contact',
    privacy: 'Confidentialité',
    terms: 'Conditions',
    disclaimer: 'Avertissement',
    footer:
      'Secure VPN propose des guides, des informations sur les fonctionnalités et des ressources sur la confidentialité en ligne.',
  },
  pt: {
    home: 'Início',
    webProxy: 'Proxy web',
    forPc: 'Para PC',
    ipChecker: 'Verificar IP',
    resources: 'Recursos',
    locations: 'Localidades',
    blog: 'Blog VPN',
    guides: 'Guias VPN',
    about: 'Sobre nós',
    contact: 'Contato',
    privacy: 'Privacidade',
    terms: 'Termos de uso',
    disclaimer: 'Aviso legal',
    footer:
      'O Secure VPN oferece guias, informações sobre recursos e conteúdos de privacidade online.',
  },
  es: {
    home: 'Inicio',
    webProxy: 'Proxy web',
    forPc: 'Para PC',
    ipChecker: 'Comprobar IP',
    resources: 'Recursos',
    locations: 'Ubicaciones',
    blog: 'Blog VPN',
    guides: 'Guías VPN',
    about: 'Sobre nosotros',
    contact: 'Contacto',
    privacy: 'Privacidad',
    terms: 'Términos de uso',
    disclaimer: 'Aviso legal',
    footer:
      'Secure VPN ofrece guías, información sobre funciones y recursos de privacidad online.',
  },
  id: {
    home: 'Beranda',
    webProxy: 'Proxy Web',
    forPc: 'Untuk PC',
    ipChecker: 'Cek IP',
    resources: 'Sumber Daya',
    locations: 'Lokasi',
    blog: 'Blog VPN',
    guides: 'Panduan VPN',
    about: 'Tentang Kami',
    contact: 'Kontak',
    privacy: 'Kebijakan Privasi',
    terms: 'Ketentuan Penggunaan',
    disclaimer: 'Penafian',
    footer:
      'Secure VPN menyediakan panduan, informasi fitur, dan sumber privasi online.',
  },
};

export function getNavigationCopy(locale = 'en') {
  return localizedNavigation[locale] || localizedNavigation.en;
}

export function getLocationLinks() {
  return Object.entries(locationLocales).map(([key, item]) => ({
    key,
    label: item.label,
    path: item.path,
  }));
}
